export const SET_IS_LOADING = "RANKING/SET_IS_LOADING";
export const SET_RANKING_LIST = "RANKING/SET_RANKING_LIST";
export const SET_TOTAL_ITEMS = "RANKING/SET_TOTAL_ITEMS";
